import React from 'react'
import FlexContainer from 'core-system/FlexContainer'
import Text from 'core-system/Text'
import palette from 'core-system/Themes/palette'
import styled from 'styled-components'
import NumberInput from 'core-system/Input/NumberInput/NumberInput'
import NumberFormatter from 'core-system/Input/NumberInput/NumberFormatter'
import FormattingUtils from 'shared/FormattingUtils'

const IconContainer = styled.div`
  min-width: 2.5rem;
  height: 2.5rem;
  background-color: ${(props) => props.theme.palette.secondary.purple600};
  border-radius: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
`

interface EmployerMaxAllocationLimitProps {
  type: 'Transit' | 'Parking'
  icon: React.ReactNode
  maxAllocationLimit: number | null
  onMaxAllocationChange: (amount: number) => void
  irsTaxLimit: number
  active: boolean
  employerContribution: number
}

const EmployerMaxAllocationLimit = ({
  type,
  icon,
  maxAllocationLimit,
  onMaxAllocationChange,
  irsTaxLimit,
  active,
  employerContribution,
}: EmployerMaxAllocationLimitProps) => {
  // Use irsTaxLimit as default if maxAllocationLimit is null (not set)
  const displayValue =
    maxAllocationLimit === null
      ? irsTaxLimit - employerContribution
      : maxAllocationLimit

  if (!active) {
    return null
  }

  const maxLimit = irsTaxLimit - employerContribution

  return (
    <FlexContainer flexDirection='column' marginBottom='1rem'>
      <Text
        variant='body2'
        textColor={palette.text.secondary}
        marginBottom='0.5rem'
      >
        {type}
      </Text>
      <FlexContainer>
        <IconContainer>{icon}</IconContainer>
        <FlexContainer
          flexDirection='column'
          justifyContent='center'
          marginLeft='1rem'
          width={'100%'}
        >
          <FlexContainer flexDirection='column'>
            <NumberInput
              padding='1rem'
              onValueChange={onMaxAllocationChange}
              value={displayValue / 100}
              iconSize={20}
              incrementVal={5}
              maxHeight='2.5rem'
            >
              <NumberFormatter decimalScale={0} fontVariant='action2' />
            </NumberInput>
          </FlexContainer>
        </FlexContainer>
      </FlexContainer>
      {displayValue > maxLimit || displayValue < 0 ? (
        <FlexContainer marginLeft='4rem' marginTop='0.25rem'>
          <Text variant='body2' textColor={palette.error.red600}>
            Please enter a value equal to or less than{' '}
            {FormattingUtils.formatDollar(maxLimit, 0)}
          </Text>
        </FlexContainer>
      ) : null}
    </FlexContainer>
  )
}

export default React.memo(EmployerMaxAllocationLimit)
